angular.module('impactx.accountassignmenttype').controller('AccountAssignmentTypeListController', [
    'selectedListItems',
    AccountAssignmentTypeListCtrl
]);

function AccountAssignmentTypeListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'AccountAssignmentType'
        },
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/accountassignmenttype/templates/accountassignmenttypelist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/accountassignmenttype/list',
        ctrl: this,
        id: "accountassignmenttypelist",
        mainAction: {id: "new", link: "#/accountassignmenttype/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "accountassignmenttype/" + selectedListItems.getFirstSelectedId();
    }
}
